import * as dateFnsTz from 'date-fns-tz'

import { Timezone } from '@/entities'

//
// Returns a Date which will format as the local time of any time zone from a specific UTC time
// If no timezone is provided this returns the original date
//
export const utcToZonedTime = (date: Date, timezone?: Timezone) => {
    if (!timezone) {
        return date
    }
    return dateFnsTz.utcToZonedTime(date, timezone)
}
